import React from "react";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import {
  ShowChart,
  Translate,
  People,
  Description,
  GetApp,
  Settings,
  AssignmentReturned,
} from "@material-ui/icons";
import MenuBookIcon from "@material-ui/icons/MenuBook";

import {useProvider} from "../Context";

function ListItemLink(props) {
  return <ListItem button component={Link} {...props} />;
}

function getQSAddedURL(url) {
  const context = useProvider();
  return url + "?activeGroup=" + context.auth.state.activeGroup;
}

export default function SideMenu({ isAdmin, isAnalysis }) {
  return (
    <div>
      <ListItemLink to={getQSAddedURL("/dashboard")}>
        <ListItemIcon>
          <ShowChart />
        </ListItemIcon>
        <ListItemText primary="ダッシュボード" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/retweets")}>
        <ListItemIcon>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary="話題分析" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/keywords")}>
        <ListItemIcon>
          <Translate />
        </ListItemIcon>
        <ListItemText primary="キーワード分析" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/users")}>
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="投稿者分析" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/tweets")}>
        <ListItemIcon>
          <Description />
        </ListItemIcon>
        <ListItemText primary="全ての投稿" />
      </ListItemLink>
      <ListItemLink to={getQSAddedURL("/download")}>
        <ListItemIcon>
          <GetApp />
        </ListItemIcon>
        <ListItemText primary="データダウンロード" />
      </ListItemLink>
      {/* Add 2023.03.31 投稿分類 */}
      {isAnalysis && (
        <ListItemLink to={getQSAddedURL("/AnalysisTask")}>
        <ListItemIcon>
          <AssignmentReturned />
        </ListItemIcon>
        <ListItemText primary="投稿分類" />
        </ListItemLink>
      )}
      {isAdmin && (
        <ListItemLink to={getQSAddedURL("/group")}>
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <ListItemText primary="収集グループ設定" />
        </ListItemLink>
      )}
    </div>
  );
}
